import { useMutation } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../api/ApiRoutes";

const declinePendingTransaction = async ({
  user_id,
  transaction_id,
  reason,
}) => {
  if (!user_id || !transaction_id || !reason) {
    return;
  }

  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.DECLINE_PENDING_TRANSACTION,
    {
      user_id,
      transaction_id,
      reason,
    }
  );

  return response?.data ?? null;
};

export const useDeclinePendingTransaction = () => {
  return useMutation({
    mutationKey: ["DECLINE_PENDING_TRANSACTION"],
    mutationFn: declinePendingTransaction,
  });
};
